var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-number"},_vm._l((_vm.digitCount),function(digit,index){return _c('div',{key:index,staticClass:"digit-wrapper",style:({
        width: _vm.digitWidth,
        height: _vm.digitHeight,
        'font-size': _vm.fontSize
    })},[_c('div',{staticClass:"digit-roller"},[_c('div',{staticClass:"digit-track",style:({
                transform: `translateY(-${_vm.currentDigits[index] * 100}%)`,
                transition: `transform ${_vm.duration}ms ease-out`
            })},_vm._l((10),function(n){return _c('div',{key:n,staticClass:"digit-item"},[_vm._v(_vm._s(n % 10))])}),0)])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }